import { render } from "./SubCategoryList.vue?vue&type=template&id=51512e90&scoped=true"
import script from "./SubCategoryList.vue?vue&type=script&lang=js"
export * from "./SubCategoryList.vue?vue&type=script&lang=js"

import "./SubCategoryList.vue?vue&type=style&index=0&id=51512e90&scoped=true&lang=css"

import exportComponent from "C:\\vue-project\\asset-labuhan-digital\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51512e90"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QDialog,QCardSection,QInput,QCardActions,QField});qInstall(script, 'directives', {ClosePopup});
